import { render, staticRenderFns } from "./CompanyProfileView.vue?vue&type=template&id=c8ad04cc&scoped=true"
import script from "./CompanyProfileView.vue?vue&type=script&lang=js"
export * from "./CompanyProfileView.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileView.vue?vue&type=style&index=0&id=c8ad04cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ad04cc",
  null
  
)

export default component.exports